module.exports = __webpack_public_path__ + "media/src/images/user/default_avatars/default_avatar_6-5cae96d7c6ed5e2e3b3b5082c92780ea.png";